var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distrib-doc",domProps:{"innerHTML":_vm._s(_vm.distributionAgreement)}})
}
var staticRenderFns = []

export { render, staticRenderFns }